import React, {Component} from 'react';
import {
  Row,
  Col,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  PanelContainer,
  Icon,
  PanelFooter, Button, Well, Form, ControlLabel, FormControl, FormGroup, InputGroup,
} from '@sketchpixy/rubix';

import {preSubscriptions, deletePreSubscription, deleteMessageCode} from '../../api/api';
import {downloadExcelTemplate} from '../../api/url';

import {Link, withRouter} from 'react-router';
import {checkRole} from '../../util/RoleChecker';
import ReactDOM from "react-dom";
import UploadExcelModal from './components/UploadExcelModal';
import RoleType from '../RoleGroup/Roles/RoleType';
import moment from "moment";
import {routeUrl} from "../routeUrl";

const tableStyle = {
  tableLayout: 'fixed'
};


@withRouter
export default class PreSubscription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showUploadModal: false,
      datatables: null,
      search: {
        status: '',
      }
    };
  }


  showUploadExcelModal = () => {
    this.setState({
      showUploadModal: true
    });
  }

  closeUploadExcelModal = (success) => {
    this.setState({
      showUploadModal: false
    });
    if(success)
    {
      this.doSearch()
    }
  }


  componentDidMount() {
    const requiredRoles = [
      RoleType.B2C_PRODUCT_LIST,
      RoleType.B2C_PRODUCT_LIST_READ_ONLY,
    ];

    checkRole(requiredRoles, this.props.router);

    let roles = JSON.parse(localStorage.getItem('roles'));
    let roleRegion = null;

    requiredRoles.forEach(requiredRoleType => {
      roles.forEach(role => {
        if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
          roleRegion = role.region;
        }
      });
    });

    let self = this;
    let datatableDom = $(ReactDOM.findDOMNode(this.dataTable));
    if ($.fn.DataTable.isDataTable(datatableDom ) ) {
      return;
    }

    let datatables = datatableDom.addClass('nowrap')
        .DataTable({
          language: { infoFiltered: "" },
          processing: true,
          serverSide: true,
          responsive: true,
          searchDelay: 2000,
          searching: false,
          ajax : function (data, callback, settings) {
            let search = self.state.search;
            let param = _.merge({}, data, search)
            preSubscriptions(param, (err, result) => {
              let rslt = result.list;
              rslt.data = self.assignData(rslt.data);
              callback(rslt);
            });
          },
          columns: [
            {title: 'Id',                   data: 'id',              name: 'id',          width: '5%',  className: "td-limit"},
            {title: 'Status',               data: 'status',          name: 'status',      width: '15%', className: "td-limit"},
            {title: 'Serial No',            data: 'serialNo',        name: 'serialNo',    width: '20%', className: "td-limit"},
            {title: 'Device',               data: 'device',          name: 'device',      width: '20%', className: "td-limit"},
            {title: 'Side',                 data: 'side',            name: 'side',        width: '20%', className: "td-limit"},
            {title: 'Created Time',         data: 'createdTime',     name: 'createdTime', width: '20%', className: "td-limit",
              render: function (d, type, row) {
                return moment.utc(d).format('YYYY-MM-DD HH:mm:ss')
              }
            },
            {title: 'Action',               data: 'action',          orderable: false, width: '10%', className: "td-limit"},
          ],
          rowId: 'id',
          select: true
        });

    this.setState({
      datatables: datatables
    },() => {
      //self.doSearch();
    });


    window.deletePreSubscription = this.deletePreSubscription
  }


  onSelectRow = (id) => {

  };

  assignData(list) {
    return list.map(ps => {
      ps.action = '<a href="#" onclick="deletePreSubscription(\'' + ps.id + '\')">Delete</a>'
      return ps
    });
  }

  deletePreSubscription = (id) => {
    let self = this;
    vex.dialog.confirm({
      message: 'Are you sure to delete this item?',
      callback: function (value) {
        if (value) {
          deletePreSubscription(id, (err, res) => {
            if (err) {
              vex.dialog.alert('Failed to delete!');
            } else if (res.statusCode != '0') {
              let message = res.statusMessage == '' ? 'Failed to upload!' : res.statusMessage;
              vex.dialog.alert(message);
            } else {
              vex.dialog.alert('Deleted!');
              self.doSearch();
            }
          });
        } else {
          console.log('delete cancel')
        }
      }
    });
  }


  downloadExcelTemplate = (evt) => {
    let self = this;
    document.location.href = `${downloadExcelTemplate}`
  }


  doSearch = (search) => {
    let param = search ? search : this.state.search
    this.setState({ search: search }, () => {
      this.state.datatables.ajax.reload();
    });
  }

  render() {
    return (
        <PanelContainer controls={false}>
          <Panel>
            <PanelHeader>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3>Pre Subscription List</h3>
                    <Well>
                      <Form inline>
                        <div className="row" >
                          <div className="col-md-1">
                            <ControlLabel style={{ paddingLeft: "20px" }}>Status</ControlLabel>
                          </div>
                          <div className="col-md-5">
                            <FormControl
                                componentClass="select"
                                onChange={this.statusChangeHandler}
                                value={''}
                                style={{width: '120px'}}>
                              <option value="">ALL</option>
                              <option value="CREATED">CREATED</option>
                              <option value="USED">USED</option>
                            </FormControl>
                          </div>

                          <div className="col-md-6">
                            <FormGroup className="pull-right">
                              <InputGroup.Button>
                                <Button onClick={this.doSearch}><i className="glyphicon glyphicon-search fa fa-search" />Search</Button>
                                <Button onClick={this.downloadExcelTemplate} className="btn-info"><i className="glyphicon glyphicon-download fa fa-download" />Download Template</Button>
                                <Button onClick={this.showUploadExcelModal} className="btn-info"><i className="glyphicon glyphicon-upload fa fa-upload" />Upload Excel</Button>
                              </InputGroup.Button>
                            </FormGroup>
                          </div>
                        </div>
                      </Form>
                    </Well>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <Table id="table" ref={(c) => this.dataTable = c} className="display" cellSpacing="0" width="100%" style={tableStyle}/>
                  </Col>
                </Row>
                <UploadExcelModal
                    showModal={this.state.showUploadModal}
                    closeModal={this.closeUploadExcelModal}
                />
              </Grid>
            </PanelBody>
            <PanelFooter>
              <Grid>
                <Row>
                  <Col xs={12} className='fg-white' style={{marginBottom: '20px'}} />
                </Row>
              </Grid>
            </PanelFooter>
          </Panel>
        </PanelContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/product/PreSubscription.js